import * as React from 'react'

import { ImageSkuBlock } from '@components'


export default function imageSkuColumn() {
    return {
        name: 'skuID', label: 'Product Image',
        options: {
		    headerAlign: 'left',
            customBodyRowRenderLite:  (value, { sku }) => <ImageSkuBlock
                skuID={value}
                skuName={sku}
            />
        }
    }
}